// Define the workshop API domain
export const workshopDomain = process.env.REACT_APP_NODE_ENV === "development"
  ? "http://localhost:5070"
  : "https://workshop.vectorindia.org/wsapi";

// Define the PhonePe payment domain
export const phonepeDomain = process.env.REACT_APP_NODE_ENV === "development"
  ? "http://localhost:5070"
  : "https://vectorindia.org/phonepe";

// Export the workshop domain as default for backward compatibility
export default workshopDomain;
